import { render, staticRenderFns } from "./maintenance_item.vue?vue&type=template&id=036380ba&scoped=true&"
import script from "./maintenance_item.vue?vue&type=script&lang=js&"
export * from "./maintenance_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036380ba",
  null
  
)

export default component.exports